<template>
  <!-- <li v-bind:class="{treeView: treeView}">
    <div v-if="item.subMenu.length > 0" @click="toggle" class="submenu-toggle">
      <span class="menu-icon">
        <span v-bind:class="item.menuIcon"></span>
      </span>
      <span>{{item.menuName}}</span>
      <span class="ml-auto sm-a">
        <b-icon icon="chevron-right"></b-icon>
      </span>
    </div>

    <router-link v-bind:to="item.url" v-else>
      <span class="menu-icon">
        <span v-bind:class="item.menuIcon"></span>
      </span>
      <span>{{item.menuName}}</span>
    </router-link>

    <ul v-if="item.subMenu.length" class="submenu">
      <li v-for="item in item.subMenu" :key="item.id">
        <router-link v-bind:to="item.url">
          <span class="menu-icon">
            <span v-bind:class="item.menuIcon"></span>
          </span>
          <span>{{item.menuName}}</span>
        </router-link>
      </li>
    </ul>
  </li> -->
  <li v-bind:class="{treeView: treeView}">
    <router-link v-bind:to="item.url">
      <span class="menu-icon">
        <span v-bind:class="item.menuIcon"></span>
      </span>
      <span>{{ item.menuName }}</span>
    </router-link>
  </li>
</template>

<script>
export default {
  props: ["item"],
  data: function() {
    return {
      open: false,
      treeView: true
    };
  },
  methods: {
    toggle() {
      this.treeView = !this.treeView;
    }
  }
};
</script>